import { getPlayerTypeBadge } from '../components/PlayerTypeBadge';

/** Asc: T → P → S; players without a type sort last. */
const PLAYER_TYPE_ORDER = { T: 0, P: 1, S: 2 };

function getSortValue(item, sortColumn) {
  if (sortColumn === 'playerType') {
    const type = getPlayerTypeBadge(item);
    return type && PLAYER_TYPE_ORDER[type] !== undefined
      ? PLAYER_TYPE_ORDER[type]
      : 99;
  }
  return item ? item[sortColumn] : undefined;
}

function sortItems(items, sortColumn, sortDirection) {
  return [...items].sort((a, b) => {
    const aVal = getSortValue(a, sortColumn);
    const bVal = getSortValue(b, sortColumn);
    const aNum = typeof aVal === 'number' && !isNaN(aVal);
    const bNum = typeof bVal === 'number' && !isNaN(bVal);

    if (aNum && bNum) {
      return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
    }

    const aStr = (aVal != null ? aVal : '').toString().toLowerCase();
    const bStr = (bVal != null ? bVal : '').toString().toLowerCase();
    if (aStr < bStr) return sortDirection === 'asc' ? -1 : 1;
    if (aStr > bStr) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });
}

export function filterSkaters(players, { position, team, searchTerm, sortColumn, sortDirection, faStatus, playerType }) {
  let filtered = players;

  if (position !== 'all' && position !== 'Goalie') {
    let filterCode = position;
    if (position === 'Right Wing') filterCode = 'R';
    if (position === 'Left Wing') filterCode = 'L';
    if (position === 'Center') filterCode = 'C';
    if (position === 'Defenseman') filterCode = 'D';

    filtered = filtered.filter(
      (p) =>
        p &&
        p.positions &&
        (p.positions.includes(filterCode) ||
          (filterCode && p.positions.some((pos) => pos.toLowerCase() === filterCode.toLowerCase())))
    );
  }

  if (team !== 'all') {
    if (team === 'Free Agents') {
      filtered = filtered.filter((p) => p && (p.isFreeAgent || p.team === 'Free Agents' || p.team === 'N/A'));
    } else {
      filtered = filtered.filter((p) => p && p.team === team);
    }
  }

  if (searchTerm) {
    const term = searchTerm.toLowerCase();
    filtered = filtered.filter((p) => p && p.name && p.name.toLowerCase().includes(term));
  }

  if (faStatus && faStatus !== 'all') {
    filtered = filtered.filter((p) => p && p.faStatus === faStatus);
  }

  if (playerType && playerType !== 'all') {
    filtered = filtered.filter((p) => p && getPlayerTypeBadge(p) === playerType);
  }

  return sortItems(filtered, sortColumn, sortDirection);
}

export function filterGoalies(goalies, { team, searchTerm, sortColumn, sortDirection, faStatus }) {
  let filtered = goalies;

  if (team !== 'all') {
    if (team === 'Free Agents') {
      filtered = filtered.filter((g) => g && (g.isFreeAgent || g.team === 'Free Agents' || g.team === 'N/A'));
    } else {
      filtered = filtered.filter((g) => g && g.team === team);
    }
  }

  if (searchTerm) {
    const term = searchTerm.toLowerCase();
    filtered = filtered.filter((g) => g && g.name && g.name.toLowerCase().includes(term));
  }

  if (faStatus && faStatus !== 'all') {
    filtered = filtered.filter((g) => g && g.faStatus === faStatus);
  }

  return sortItems(filtered, sortColumn, sortDirection);
}
